import React, { Fragment } from 'react';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';

import { makeStyles } from '@material-ui/core/styles';
import SentImage from '../../assets/images/email-sent.gif';

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(4)
  },
  submit: {
    margin: theme.spacing(3, 0, 2)
  },
  successMsg: {
    marginTop: theme.spacing(10),
    fontSize: '17px',
    fontWeight: 'bold'
  },
  successHeading: {
    color: 'green'
  },
  errorMsg: {
    color: 'red',
    fontSize: '20px'
  }
}));

export default function SignUp(props) {
  const {
    handleLogin,
    handleChange,
    handleSubmit,
    validationErrors,
    isRegistrationSuccess,
    serverErrorMsg,
    isSubmitting
  } = props;
  const classes = useStyles();

  return (
    <Fragment>
      <CssBaseline />
      <div className="sign-up-outer-area position-relative">
        <div className="sign-up-bg">
          <svg
            width="1920"
            height="970"
            viewBox="0 0 1920 970"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <ellipse cx="1527.5" cy="-273" rx="516.5" ry="513" fill="#FF5EB4" fillOpacity="0.1" />
            <circle cx="334" cy="608" r="475" fill="#7E7EFF" fillOpacity="0.1" />
            <circle cx="1720" cy="784" r="324" fill="#F9D21E" fillOpacity="0.1" />
            <ellipse cx="1527.5" cy="1146" rx="516.5" ry="513" fill="#FF5EB4" fillOpacity="0.1" />
            <ellipse cx="424.5" cy="1146" rx="516.5" ry="513" fill="#5EFFD8" fillOpacity="0.1" />
            <ellipse cx="424.5" cy="-61" rx="516.5" ry="513" fill="#5EFFD8" fillOpacity="0.1" />
          </svg>
        </div>

        <div className={classes.paper}>
          {isRegistrationSuccess ? (
            <div className="container mb-0 position-relative sign-up-wrapper email-sent-section">
              <div className="row align-items-center justify-content-center m-auto">
                <div className="ex-card mx-3 text-center">
                  <img className="sent-img-email" src={SentImage} />

                  <h4>You have registered Successfully</h4>
                  <p>
                    We have sent an email to activate your account, Please follow the instructions
                    in the email and activate your account before login. If you have already
                    activated your account
                    <Link onClick={handleLogin} href="#" variant="body2">
                      {' '}
                      please click here to login.
                    </Link>
                  </p>
                </div>
              </div>
            </div>
          ) : (
            <>
              <div className="container mb-0 position-relative sign-up-wrapper">
                <div className="row align-items-center">
                  <div className="col-lg-6">
                    <div className="logo-brand-sign-up">
                      <svg
                        width="245"
                        height="46"
                        viewBox="0 0 245 46"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M15.0202 7.19409C20.6041 17.6621 22.5817 28.0148 22.1738 38.1912C20.3614 30.5144 18.3596 24.7486 3.46863 21.3874C16.0486 20.9125 16.2412 18.9785 15.0202 7.19409Z"
                          fill="#1363DF"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M35.8004 14.3147C29.8424 21.968 26.8337 30.3022 26.9936 39.6598C30.5557 34.436 35.49 31.5309 42.082 31.4262C32.227 29.8063 31.858 23.1944 35.8004 14.3147Z"
                          fill="#1363DF"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M0.133057 23.095C0.446261 34.4258 43.903 53.2007 48.7631 42.4673C49.8688 40.0253 47.0254 36.2266 41.8535 32.3821C44.7453 35.0945 46.1226 37.6086 45.3627 39.3946C43.6788 43.3595 32.1089 42.238 19.5251 36.8903C9.70661 32.7165 2.16868 27.2011 0.133057 23.095Z"
                          fill="#1363DF"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M8.84941 17.4902C4.30174 16.912 1.05739 17.4687 0.212515 19.2969C-0.80742 21.5067 1.91186 25.0602 6.90975 28.7C3.26447 25.7455 1.3923 22.9603 2.22867 21.1487C3.04847 19.3747 6.30079 18.8896 10.8249 19.5495C10.3631 19.3751 9.94601 19.0996 9.60422 18.7434C9.26243 18.3871 9.00455 17.9589 8.84941 17.4902ZM39.0261 32.4068C41.8977 34.9871 43.2893 37.3637 42.5466 38.9714C42.3216 39.4583 41.9115 39.8464 41.3442 40.1421C42.4833 39.8137 43.2767 39.2683 43.6355 38.4922C44.3598 36.9234 43.1979 34.6751 40.6738 32.2C40.1119 32.2465 39.5627 32.3154 39.0263 32.4068H39.0261Z"
                          fill="#1363DF"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M35.2928 11.1617C28.909 20.0746 25.4742 29.8939 24.0563 40.335C23.7389 27.3653 20.4666 14.6718 14.2393 2.25439C20.5353 13.0684 27.3069 18.7107 35.2928 11.1617Z"
                          fill="#1363DF"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M28.078 1.65513L21.7179 2.12357L24.5351 4.05505C26.058 3.81128 27.6807 4.16144 29.3516 4.79558C27.7645 4.48721 26.28 4.29053 25.1324 4.46454L25.8397 4.94951L27.8238 5.13292L30.0812 5.61294L33.4855 5.3622L28.078 1.65513Z"
                          fill="#1363DF"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M30.3604 4.09506L24.9899 3.58555L24.9483 4.24309C26.3321 4.1375 27.7903 4.50008 29.2865 5.10109C27.6338 4.76207 26.0908 4.54976 24.9153 4.76611L24.8313 6.09439C24.8313 6.09439 26.2421 5.80813 27.5771 6.05644C28.912 6.30475 30.1712 7.08764 30.1712 7.08764L30.3604 4.09506Z"
                          fill="#1363DF"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M22.9293 3.08122C22.4679 3.92488 21.7485 4.6675 21.5443 5.61286C21.4147 6.21437 21.8271 6.88942 21.9678 7.5279C21.8594 6.84678 21.9023 6.17565 22.0942 5.55066C22.3323 4.77802 22.855 4.12603 23.2353 3.41378C23.1329 3.30293 23.0309 3.19207 22.9293 3.08122Z"
                          fill="#1363DF"
                        />
                        <path
                          d="M22.1519 6.59004L21.3824 6.7251L21.7547 8.02617L22.5241 7.89111L22.1519 6.59004Z"
                          fill="#1363DF"
                        />
                        <path
                          d="M25.2012 8.92469C24.9765 8.85727 24.7934 8.64431 24.7676 8.39867L24.7477 8.20867C24.7171 7.91804 24.9187 7.6918 25.1977 7.70278L25.2586 6.70799C25.2586 6.70799 26.2998 6.51834 27.3094 6.71136C28.319 6.90438 29.2967 7.47999 29.2967 7.47999L29.2352 8.4841C29.3342 8.51051 29.4245 8.5677 29.4881 8.64437C29.5517 8.72103 29.584 8.81158 29.5787 8.89812L29.5465 9.42431C29.5409 9.51595 29.4935 9.59581 29.4148 9.64632C29.336 9.69683 29.2324 9.71384 29.1266 9.69363L29.0834 9.68536C28.7689 10.6862 27.8818 11.6291 27.0408 11.4683C26.1947 11.3066 25.3956 10.0283 25.2012 8.92469Z"
                          fill="#1363DF"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M8.88753 14.7297C8.88753 14.7297 9.42715 13.942 10.2929 13.4758C11.1587 13.0096 12.3507 12.8648 12.3507 12.8648L12.0108 12.2962L13.739 10.6416L8.92019 10.8851L5.47579 14.1828L7.98635 14.0559C8.7506 13.1843 9.84579 12.6358 11.0992 12.2418C10.0148 12.8147 9.04722 13.4101 8.47168 14.083L8.88753 14.7297Z"
                          fill="#1363DF"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M7.29896 13.3634C7.0097 13.8111 6.61637 14.2196 6.43065 14.7067C6.31262 15.0167 6.42739 15.339 6.42553 15.6552C6.44606 15.3159 6.53259 14.9747 6.68047 14.65C6.86373 14.2486 7.16087 13.8949 7.40099 13.5174C7.36687 13.466 7.33286 13.4147 7.29896 13.3634Z"
                          fill="#1363DF"
                        />
                        <path
                          d="M6.25545 15.2518L6.3313 15.8481L6.77793 15.746L6.70208 15.1496L6.25545 15.2518Z"
                          fill="#1363DF"
                        />
                        <path
                          d="M10.0928 16.6315C9.92358 16.7216 9.73492 16.7081 9.63903 16.5873L9.56493 16.494C9.4517 16.3511 9.51131 16.1126 9.69817 15.9606L9.41863 15.3784C9.41863 15.3784 10.0417 14.6845 10.7669 14.2192C11.4921 13.754 12.3193 13.5174 12.3193 13.5174L12.6064 14.1154C12.6899 14.083 12.7721 14.0734 12.8409 14.088C12.9096 14.1026 12.9612 14.1407 12.988 14.1966L13.0801 14.3884C13.1102 14.4511 13.1072 14.5322 13.0718 14.6169C13.0364 14.7016 12.9708 14.7841 12.8871 14.8493C13.0034 15.5786 12.7235 16.6023 12.1185 16.9905C11.5106 17.3805 10.5752 17.129 10.0928 16.6315Z"
                          fill="#1363DF"
                        />
                        <path
                          d="M38.0134 23.6233C37.9407 23.4811 38.0222 23.2393 38.2257 23.0338L38.3832 22.8748C38.624 22.6317 38.9444 22.5313 39.0995 22.6502L40.0214 21.883C40.0214 21.883 40.8052 22.1433 41.2295 22.6954C41.6538 23.2474 41.7186 24.0912 41.7186 24.0912L40.7853 24.8677C40.8156 24.9335 40.8134 25.0184 40.779 25.107C40.7446 25.1956 40.6804 25.282 40.5979 25.3506L40.1589 25.7159C40.0675 25.7919 39.9609 25.8402 39.8625 25.8499C39.764 25.8597 39.6819 25.8302 39.6341 25.768L39.6287 25.761C38.5517 26.4328 37.1881 26.8324 36.8346 26.3726C36.479 25.9099 37.1453 24.5778 38.0134 23.6233Z"
                          fill="#1363DF"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M39.1214 21.8276C39.1214 21.8276 40.3426 22.2103 41.0859 22.9529C41.8292 23.6956 42.0946 24.7982 42.0946 24.7982L43.0603 24.0519L45.7553 25.0961L45.5517 19.5399L40.1808 17.4585L40.2867 20.3534C41.7125 20.7304 42.5837 21.6948 43.1899 22.9399C42.2773 22.0033 41.3222 21.2182 40.2209 20.9441L39.1214 21.8276Z"
                          fill="#1363DF"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M41.1188 18.2949C40.5237 18.1643 39.9864 17.8654 39.3332 17.9026C38.9176 17.9264 38.4757 18.2806 38.0468 18.4694C38.5062 18.2926 38.9654 18.2062 39.3996 18.215C39.9364 18.2264 40.4038 18.4247 40.9057 18.5295C40.9768 18.4511 41.0478 18.3729 41.1188 18.2949Z"
                          fill="#1363DF"
                        />
                        <path
                          d="M38.6065 17.7726L37.7767 18.147L37.9021 18.5598L38.7318 18.1855L38.6065 17.7726Z"
                          fill="#1363DF"
                        />
                        <path
                          d="M64.5722 32V13.8H77.2602V17.57H68.8622V28.23H77.5202V32H64.5722ZM66.6522 24.538V20.95H76.0902V24.538H66.6522ZM89.39 32L86.452 27.554L85.1 25.656L79.64 18.194H84.632L87.466 22.432L88.948 24.46L94.33 32H89.39ZM79.51 32L85.074 24.252L87.31 26.93L84.424 32H79.51ZM88.636 25.994L86.426 23.342L89.156 18.194H94.07L88.636 25.994ZM100.964 32.234C99.8031 32.234 98.7631 31.9307 97.8445 31.324C96.9431 30.7 96.2238 29.8507 95.6865 28.776C95.1491 27.684 94.8805 26.4533 94.8805 25.084C94.8805 23.68 95.1491 22.4407 95.6865 21.366C96.2238 20.2913 96.9605 19.4507 97.8965 18.844C98.8325 18.22 99.8985 17.908 101.094 17.908C101.753 17.908 102.351 18.0033 102.888 18.194C103.443 18.3847 103.928 18.6533 104.344 19C104.76 19.3293 105.116 19.7193 105.41 20.17C105.705 20.6033 105.922 21.0713 106.06 21.574L105.202 21.47V18.194H109.336V32H105.124V28.672L106.06 28.646C105.922 29.1313 105.696 29.5907 105.384 30.024C105.072 30.4573 104.691 30.8387 104.24 31.168C103.79 31.4973 103.287 31.7573 102.732 31.948C102.178 32.1387 101.588 32.234 100.964 32.234ZM102.108 28.724C102.75 28.724 103.304 28.5767 103.772 28.282C104.24 27.9873 104.604 27.5713 104.864 27.034C105.124 26.4793 105.254 25.8293 105.254 25.084C105.254 24.3387 105.124 23.6973 104.864 23.16C104.604 22.6053 104.24 22.1807 103.772 21.886C103.304 21.574 102.75 21.418 102.108 21.418C101.484 21.418 100.938 21.574 100.47 21.886C100.02 22.1807 99.6645 22.6053 99.4045 23.16C99.1445 23.6973 99.0145 24.3387 99.0145 25.084C99.0145 25.8293 99.1445 26.4793 99.4045 27.034C99.6645 27.5713 100.02 27.9873 100.47 28.282C100.938 28.5767 101.484 28.724 102.108 28.724ZM112.981 32V18.194H116.933L117.063 20.69L116.517 20.716C116.725 20.2653 116.985 19.8667 117.297 19.52C117.626 19.1733 117.99 18.8873 118.389 18.662C118.805 18.4193 119.23 18.2373 119.663 18.116C120.114 17.9947 120.564 17.934 121.015 17.934C121.691 17.934 122.306 18.038 122.861 18.246C123.416 18.454 123.901 18.792 124.317 19.26C124.733 19.7107 125.062 20.326 125.305 21.106L124.655 21.054L124.863 20.638C125.088 20.222 125.374 19.8493 125.721 19.52C126.085 19.1733 126.484 18.8873 126.917 18.662C127.35 18.4193 127.801 18.2373 128.269 18.116C128.737 17.9947 129.188 17.934 129.621 17.934C130.713 17.934 131.623 18.1507 132.351 18.584C133.079 19 133.625 19.6327 133.989 20.482C134.37 21.3313 134.561 22.3627 134.561 23.576V32H130.375V23.914C130.375 23.3593 130.297 22.9 130.141 22.536C129.985 22.172 129.751 21.9033 129.439 21.73C129.144 21.5393 128.772 21.444 128.321 21.444C127.957 21.444 127.619 21.5047 127.307 21.626C127.012 21.7473 126.752 21.912 126.527 22.12C126.319 22.328 126.154 22.5707 126.033 22.848C125.912 23.1253 125.851 23.4373 125.851 23.784V32H121.665V23.888C121.665 23.368 121.587 22.926 121.431 22.562C121.275 22.198 121.041 21.9207 120.729 21.73C120.417 21.5393 120.053 21.444 119.637 21.444C119.273 21.444 118.935 21.5047 118.623 21.626C118.328 21.7473 118.068 21.912 117.843 22.12C117.635 22.328 117.47 22.5707 117.349 22.848C117.228 23.1253 117.167 23.4287 117.167 23.758V32H112.981Z"
                          fill="#072046"
                        />
                        <path
                          d="M143.113 32.234C141.952 32.234 140.912 31.9307 139.993 31.324C139.092 30.7 138.372 29.8507 137.835 28.776C137.298 27.684 137.029 26.4533 137.029 25.084C137.029 23.68 137.298 22.4407 137.835 21.366C138.372 20.2913 139.109 19.4507 140.045 18.844C140.981 18.22 142.047 17.908 143.243 17.908C143.902 17.908 144.5 18.0033 145.037 18.194C145.592 18.3847 146.077 18.6533 146.493 19C146.909 19.3293 147.264 19.7193 147.559 20.17C147.854 20.6033 148.07 21.0713 148.209 21.574L147.351 21.47V18.194H151.485V32H147.273V28.672L148.209 28.646C148.07 29.1313 147.845 29.5907 147.533 30.024C147.221 30.4573 146.84 30.8387 146.389 31.168C145.938 31.4973 145.436 31.7573 144.881 31.948C144.326 32.1387 143.737 32.234 143.113 32.234ZM144.257 28.724C144.898 28.724 145.453 28.5767 145.921 28.282C146.389 27.9873 146.753 27.5713 147.013 27.034C147.273 26.4793 147.403 25.8293 147.403 25.084C147.403 24.3387 147.273 23.6973 147.013 23.16C146.753 22.6053 146.389 22.1807 145.921 21.886C145.453 21.574 144.898 21.418 144.257 21.418C143.633 21.418 143.087 21.574 142.619 21.886C142.168 22.1807 141.813 22.6053 141.553 23.16C141.293 23.6973 141.163 24.3387 141.163 25.084C141.163 25.8293 141.293 26.4793 141.553 27.034C141.813 27.5713 142.168 27.9873 142.619 28.282C143.087 28.5767 143.633 28.724 144.257 28.724ZM155.156 32V18.194H159.108L159.238 21.002L158.406 21.314C158.596 20.69 158.934 20.1267 159.42 19.624C159.922 19.104 160.52 18.688 161.214 18.376C161.907 18.064 162.635 17.908 163.398 17.908C164.438 17.908 165.313 18.1247 166.024 18.558C166.734 18.974 167.272 19.6067 167.636 20.456C168 21.288 168.182 22.3107 168.182 23.524V32H163.996V23.862C163.996 23.3073 163.918 22.848 163.762 22.484C163.606 22.12 163.363 21.8513 163.034 21.678C162.722 21.4873 162.332 21.4007 161.864 21.418C161.5 21.418 161.162 21.4787 160.85 21.6C160.538 21.704 160.269 21.8687 160.044 22.094C159.818 22.302 159.636 22.5447 159.498 22.822C159.376 23.0993 159.316 23.4027 159.316 23.732V32H157.262C156.776 32 156.36 32 156.014 32C155.667 32 155.381 32 155.156 32ZM173.275 37.98L176.421 30.57L176.473 32.702L169.817 18.194H174.523L177.435 25.136C177.591 25.4827 177.738 25.8553 177.877 26.254C178.015 26.6527 178.119 27.034 178.189 27.398L177.617 27.736C177.721 27.476 177.833 27.1553 177.955 26.774C178.093 26.3753 178.241 25.9507 178.397 25.5L180.945 18.194H185.677L179.801 32L177.409 37.98H173.275ZM188.8 32V14.71H192.96V32H188.8ZM186.356 21.834V18.194H195.638V21.834H186.356ZM198.249 32V18.194H202.409V32H198.249ZM200.329 15.464C199.549 15.464 198.934 15.282 198.483 14.918C198.05 14.5367 197.833 13.9993 197.833 13.306C197.833 12.682 198.058 12.1707 198.509 11.772C198.96 11.3733 199.566 11.174 200.329 11.174C201.109 11.174 201.716 11.3647 202.149 11.746C202.582 12.11 202.799 12.63 202.799 13.306C202.799 13.9473 202.574 14.4673 202.123 14.866C201.69 15.2647 201.092 15.464 200.329 15.464ZM206.292 32V18.194H210.244L210.374 20.69L209.828 20.716C210.036 20.2653 210.296 19.8667 210.608 19.52C210.937 19.1733 211.301 18.8873 211.7 18.662C212.116 18.4193 212.54 18.2373 212.974 18.116C213.424 17.9947 213.875 17.934 214.326 17.934C215.002 17.934 215.617 18.038 216.172 18.246C216.726 18.454 217.212 18.792 217.628 19.26C218.044 19.7107 218.373 20.326 218.616 21.106L217.966 21.054L218.174 20.638C218.399 20.222 218.685 19.8493 219.032 19.52C219.396 19.1733 219.794 18.8873 220.228 18.662C220.661 18.4193 221.112 18.2373 221.58 18.116C222.048 17.9947 222.498 17.934 222.932 17.934C224.024 17.934 224.934 18.1507 225.662 18.584C226.39 19 226.936 19.6327 227.3 20.482C227.681 21.3313 227.872 22.3627 227.872 23.576V32H223.686V23.914C223.686 23.3593 223.608 22.9 223.452 22.536C223.296 22.172 223.062 21.9033 222.75 21.73C222.455 21.5393 222.082 21.444 221.632 21.444C221.268 21.444 220.93 21.5047 220.618 21.626C220.323 21.7473 220.063 21.912 219.838 22.12C219.63 22.328 219.465 22.5707 219.344 22.848C219.222 23.1253 219.162 23.4373 219.162 23.784V32H214.976V23.888C214.976 23.368 214.898 22.926 214.742 22.562C214.586 22.198 214.352 21.9207 214.04 21.73C213.728 21.5393 213.364 21.444 212.948 21.444C212.584 21.444 212.246 21.5047 211.934 21.626C211.639 21.7473 211.379 21.912 211.154 22.12C210.946 22.328 210.781 22.5707 210.66 22.848C210.538 23.1253 210.478 23.4287 210.478 23.758V32H206.292ZM237.905 32.26C236.38 32.26 235.054 31.9567 233.927 31.35C232.801 30.726 231.925 29.8853 231.301 28.828C230.677 27.7533 230.365 26.5313 230.365 25.162C230.365 24.1047 230.539 23.134 230.885 22.25C231.232 21.366 231.717 20.6033 232.341 19.962C232.965 19.3033 233.702 18.8007 234.551 18.454C235.418 18.09 236.363 17.908 237.385 17.908C238.356 17.908 239.24 18.0813 240.037 18.428C240.852 18.7747 241.554 19.26 242.143 19.884C242.733 20.508 243.183 21.2447 243.495 22.094C243.807 22.9433 243.946 23.8707 243.911 24.876L243.885 25.994H232.887L232.289 23.654H240.505L240.063 24.148V23.628C240.029 23.1947 239.89 22.8133 239.647 22.484C239.422 22.1373 239.119 21.8687 238.737 21.678C238.356 21.4873 237.923 21.392 237.437 21.392C236.761 21.392 236.181 21.5307 235.695 21.808C235.227 22.068 234.872 22.458 234.629 22.978C234.387 23.4807 234.265 24.1047 234.265 24.85C234.265 25.6127 234.421 26.28 234.733 26.852C235.063 27.4067 235.531 27.84 236.137 28.152C236.761 28.464 237.498 28.62 238.347 28.62C238.937 28.62 239.457 28.5333 239.907 28.36C240.375 28.1867 240.878 27.892 241.415 27.476L243.365 30.232C242.828 30.7 242.256 31.0813 241.649 31.376C241.043 31.6707 240.419 31.8873 239.777 32.026C239.153 32.182 238.529 32.26 237.905 32.26Z"
                          fill="#1363DF"
                        />
                      </svg>
                      <h1>Get Started Now!</h1>
                      <p>Discover the most exclusive exams through our portal</p>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="ex-card form-card">
                      <h4>Sign up</h4>
                      <p>Give us some of your details to get free access Examanytime portal</p>
                      {serverErrorMsg ? <p className={classes.errorMsg}>{serverErrorMsg}</p> : null}
                      <form className={classes.form} noValidate>
                        <Grid container spacing={2}>
                          <Grid item xs={12} sm={6}>
                            <TextField
                              className="form-control"
                              autoComplete="fname"
                              name="firstName"
                              variant="outlined"
                              required
                              fullWidth
                              id="firstName"
                              label="First Name"
                              autoFocus
                              onChange={handleChange}
                              error={!!validationErrors.firstName}
                              helperText={validationErrors.firstName}
                              inputProps={{
                                maxLength: 25
                              }}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <TextField
                              variant="outlined"
                              required
                              fullWidth
                              id="lastName"
                              label="Last Name"
                              name="lastName"
                              autoComplete="lname"
                              onChange={handleChange}
                              error={!!validationErrors.lastName}
                              helperText={validationErrors.lastName}
                              inputProps={{
                                maxLength: 25
                              }}
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <TextField
                              variant="outlined"
                              required
                              fullWidth
                              id="email"
                              label="Email Address"
                              name="email"
                              autoComplete="email"
                              onChange={handleChange}
                              error={!!validationErrors.email}
                              helperText={validationErrors.email}
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <TextField
                              variant="outlined"
                              required
                              fullWidth
                              name="userName"
                              label="User Name"
                              id="userName"
                              onChange={handleChange}
                              error={!!validationErrors.userName}
                              helperText={validationErrors.userName}
                              inputProps={{
                                maxLength: 25
                              }}
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <TextField
                              variant="outlined"
                              required
                              fullWidth
                              name="password"
                              label="Password"
                              type="password"
                              id="password"
                              onChange={handleChange}
                              error={!!validationErrors.password}
                              helperText={validationErrors.password}
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <TextField
                              variant="outlined"
                              required
                              fullWidth
                              name="confirmPassword"
                              label="Confirm Password"
                              type="password"
                              id="confirmPassword"
                              onChange={handleChange}
                              error={!!validationErrors.confirmPassword}
                              helperText={validationErrors.confirmPassword}
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <TextField
                              className="promo-code"
                              name="promoCode"
                              variant="outlined"
                              fullWidth
                              id="PromoCode"
                              label=" Enter Promo Code"
                              onChange={handleChange}
                              inputProps={{
                                maxLength: 25
                              }}
                            />
                          </Grid>
                        </Grid>
                        <Button
                          type="submit"
                          fullWidth
                          variant="contained"
                          color="primary"
                          className={classes.submit}
                          onClick={handleSubmit}
                          disabled={isSubmitting}
                        >
                          Sign Up
                        </Button>
                        <Grid container justifyContent="flex-center" className="sign-in-link">
                          <Grid item>
                            <Link onClick={handleLogin} href="#" variant="body2">
                              Already have an account? Sign in
                            </Link>
                          </Grid>
                        </Grid>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
        <div className="d-flex align-items-center flex-column">
          <div className="follow-us text-center mt-5">
            <h6 className="t2">Follow Us</h6>

            <div className="d-flex justify-content-start mt-3 social-links">
              <a className="mr-2 d-flex align-items-center" href="#">
                <i className="fab fa-twitter mr-2"></i>
                <span>Twitter</span>
              </a>
              <a
                className="mr-2 d-flex align-items-center"
                href="https://www.facebook.com/ExamAnytime?mibextid=LQQJ4d"
              >
                <i className="fab fa-facebook-f mr-2"></i>
                <span>Facebook</span>
              </a>
              <a className="mr-2 d-flex align-items-center" href="#">
                <i className="fab fa-linkedin-in mr-2"></i>
                <span>Linkedin</span>
              </a>
              <a className="mr-2 d-flex align-items-center" href="#">
                <i className="fab fa-instagram mr-2"></i>
                <span>Instagram</span>
              </a>
            </div>
          </div>
          <p className="text-copy-right mb-0 mt-2">© 2024 Examanytime. All rights reserved.</p>
        </div>
      </div>
    </Fragment>
  );
}
